"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { catchError, exhaustMap, map, mergeMap, switchMap } from "rxjs/operators";

import { requestTypes, cxAlwaysInTouchConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import {
     ajaxError,
     cxAddWinnersComplete,
     cxGetJobRolesComplete,
     cxGetWinnerFilterOptionsComplete,
     cxGetWinnersComplete,
     cxGetWinnersExportComplete,
} from "../_actions";

export const cxGetWinnersEpic = (actions$) => {
     return actions$.pipe(
          ofType(cxAlwaysInTouchConstants.CX_GET_WINNERS_REQUEST),
          switchMap((action) => {
               return ajax
                    .post(
                         "/api/cxAlwaysInTouch/getWinners",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return cxGetWinnersComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const cxGetWinnersExportEpic = (actions$) => {
     return actions$.pipe(
          ofType(cxAlwaysInTouchConstants.CX_GET_WINNERS_EXPORT_REQUEST),
          // exhaustMap, so a second click while the export is still running is ignored rather than
          // queued. The call returns every matching row and can be slow.
          exhaustMap((action) => {
               return ajax
                    .post(
                         "/api/cxAlwaysInTouch/getWinnersExport",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return cxGetWinnersExportComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const cxGetWinnerFilterOptionsEpic = (actions$) => {
     return actions$.pipe(
          ofType(cxAlwaysInTouchConstants.CX_GET_WINNER_FILTER_OPTIONS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/cxAlwaysInTouch/getWinnerFilterOptions",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return cxGetWinnerFilterOptionsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const cxGetJobRolesEpic = (actions$) => {
     return actions$.pipe(
          ofType(cxAlwaysInTouchConstants.CX_GET_JOB_ROLES_REQUEST),
          mergeMap(() => {
               return ajax
                    .post(
                         "/api/cxAlwaysInTouch/getJobRoles",
                         {},
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return cxGetJobRolesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const cxAddWinnersEpic = (actions$) => {
     return actions$.pipe(
          ofType(cxAlwaysInTouchConstants.CX_ADD_WINNERS_REQUEST),
          // exhaustMap, never mergeMap. A double submit here pays every winner twice, which is
          // exactly what happened to 27 retail winners.
          exhaustMap((action) => {
               return ajax
                    .post(
                         "/api/cxAlwaysInTouch/addWinners",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return cxAddWinnersComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};
